import {ArchiveRegularIcon} from 'shells/icon/svg/archive-regular-icon';
import {PencilOutlineIcon} from 'shells/icon/svg/pencil-outline-icon';
import {StarRegularIcon} from 'shells/icon/svg/star-regular-icon';
import {UndoRegularIcon} from 'shells/icon/svg/undo-regular-icon';
import type {ToolbarOption} from 'shells/toolbar/toolbar';

import {PeepRelationshipType} from 'nutshell-graphql-types';

import type {UpdateContactRelationshipMapInput} from '../../../types';

export function getToolbarOptions(
    contactId: string,
    isFormer: boolean,
    isPrimary: boolean,
    handleUpdateContactMap: (input: UpdateContactRelationshipMapInput) => void,
    setIsEditingContactId: (contactId: string | null) => void
): ToolbarOption[] {
    const toolbarOptions: ToolbarOption[] = [
        {
            id: 'contact-edit',
            tooltipText: 'Edit person',
            icon: PencilOutlineIcon,
            onClick: () => {
                setIsEditingContactId(contactId);
            },
        },
    ];

    if (isFormer) {
        toolbarOptions.push({
            id: 'contact-mark-as-current',
            tooltipText: 'Mark as current',
            icon: UndoRegularIcon,
            onClick: () => {
                handleUpdateContactMap({
                    contact: contactId,
                    relationshipType: PeepRelationshipType.UNDEFINED,
                });
            },
        });
    } else {
        if (!isPrimary) {
            toolbarOptions.push({
                id: 'contact-mark-as-primary',
                tooltipText: 'Mark as primary',
                icon: StarRegularIcon,
                onClick: () => {
                    handleUpdateContactMap({
                        contact: contactId,
                        relationshipType: PeepRelationshipType.PRIMARY_CONTACT,
                    });
                },
            });
        }
        toolbarOptions.push({
            id: 'contact-mark-as-former',
            tooltipText: 'Mark as former',
            icon: ArchiveRegularIcon,
            onClick: () => {
                handleUpdateContactMap({
                    contact: contactId,
                    relationshipType: PeepRelationshipType.FORMER_CONTACT,
                });
            },
        });
    }

    return toolbarOptions;
}
